export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Agência', field: 'agency', sortable: false },
  { name: 'Conta', field: 'account', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
